__turbopack_context__.v({
  "badge": "StandardHero-module-scss-module___rWMjq__badge",
  "crumb": "StandardHero-module-scss-module___rWMjq__crumb",
  "hero": "StandardHero-module-scss-module___rWMjq__hero",
  "row2": "StandardHero-module-scss-module___rWMjq__row2",
  "search": "StandardHero-module-scss-module___rWMjq__search",
  "searchRow": "StandardHero-module-scss-module___rWMjq__searchRow",
  "sub": "StandardHero-module-scss-module___rWMjq__sub",
  "title": "StandardHero-module-scss-module___rWMjq__title",
  "top": "StandardHero-module-scss-module___rWMjq__top",
  "wrap": "StandardHero-module-scss-module___rWMjq__wrap",
});
